import { ClientReplenishmentReportView } from "@redotech/redo-views-common/views";
import * as z from "zod";
import { null as zNull } from "zod";

export const getReplenishmentReportViews = {
  name: "getReplenishmentReportViews" as const,
  input: zNull(),
  output: z.object({ views: z.array(ClientReplenishmentReportView) }),
};
